import { TransportOptionSelection } from '../../../transport-options-panel/transport-options-panel.model';

export class TransportRouteSelection {
    vehicleId: number;
    transportOptions: Array<TransportOptionSelection>;
}
